/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type HexVersionLogicFragment = {
  readonly __typename: "HexVersion";
  readonly id: c.HexVersionId;
  readonly name: string | null;
  readonly date: c.DateTimeString;
  readonly published: boolean;
  readonly version: c.HexVersionString;
  readonly preview: boolean;
  readonly vcsSyncError: boolean;
  readonly hex: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly updatedDate: c.DateTimeString;
    readonly lastPublishedVersion: {
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
    } | null;
    readonly versions: ReadonlyArray<{
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
      readonly version: c.HexVersionString;
    }>;
  };
};

export type SaveVersionMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  name: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  runDefaultAppSession: Types.Scalars["Boolean"]["input"];
  preview: Types.Scalars["Boolean"]["input"];
  pushToGithub: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  forcePush: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  profileColumns: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type SaveVersionMutation = {
  readonly __typename: "Mutation";
  readonly saveNewHexVersion: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
    readonly name: string | null;
    readonly date: c.DateTimeString;
    readonly published: boolean;
    readonly version: c.HexVersionString;
    readonly preview: boolean;
    readonly vcsSyncError: boolean;
    readonly hex: {
      readonly __typename: "Hex";
      readonly id: c.HexId;
      readonly updatedDate: c.DateTimeString;
      readonly lastPublishedVersion: {
        readonly __typename: "HexVersion";
        readonly id: c.HexVersionId;
      } | null;
      readonly versions: ReadonlyArray<{
        readonly __typename: "HexVersion";
        readonly id: c.HexVersionId;
        readonly version: c.HexVersionString;
      }>;
    };
  };
};

export type PublishVersionMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  name: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  version: Types.Scalars["HexVersionString"]["input"];
  forcePush: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  screenshotAppSessionId: Types.InputMaybe<
    Types.Scalars["AppSessionId"]["input"]
  >;
}>;

export type PublishVersionMutation = {
  readonly __typename: "Mutation";
  readonly publishHexVersion: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
    readonly name: string | null;
    readonly date: c.DateTimeString;
    readonly published: boolean;
    readonly version: c.HexVersionString;
    readonly preview: boolean;
    readonly vcsSyncError: boolean;
    readonly hex: {
      readonly __typename: "Hex";
      readonly id: c.HexId;
      readonly updatedDate: c.DateTimeString;
      readonly lastPublishedVersion: {
        readonly __typename: "HexVersion";
        readonly id: c.HexVersionId;
      } | null;
      readonly versions: ReadonlyArray<{
        readonly __typename: "HexVersion";
        readonly id: c.HexVersionId;
        readonly version: c.HexVersionString;
      }>;
    };
  };
};

export type RestoreVersionMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  version: Types.Scalars["HexVersionString"]["input"];
}>;

export type RestoreVersionMutation = {
  readonly __typename: "Mutation";
  readonly restoreHexVersion: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
    readonly name: string | null;
    readonly date: c.DateTimeString;
    readonly published: boolean;
    readonly hex: {
      readonly __typename: "Hex";
      readonly id: c.HexId;
      readonly updatedDate: c.DateTimeString;
      readonly versions: ReadonlyArray<{
        readonly __typename: "HexVersion";
        readonly id: c.HexVersionId;
        readonly version: c.HexVersionString;
        readonly name: string | null;
        readonly date: c.DateTimeString;
        readonly published: boolean;
      }>;
    };
  };
};

export type DeleteHexMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  getProjectCount?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  getSharedComponentCount?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type DeleteHexMutation = {
  readonly __typename: "Mutation";
  readonly deleteHex: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly trashDate: c.DateTimeString | null;
    readonly org: {
      readonly __typename: "Org";
      readonly id: c.OrgId;
      readonly projectCount?: number;
      readonly sharedComponentCount?: number;
    };
  };
};

export type HardDeleteHexMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type HardDeleteHexMutation = {
  readonly __typename: "Mutation";
  readonly hardDeleteHex: string;
};

export type RestoreHexMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type RestoreHexMutation = {
  readonly __typename: "Mutation";
  readonly restoreHex: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly trashDate: c.DateTimeString | null;
    readonly canEdit: boolean;
    readonly canShare: boolean;
  };
};

export type DuplicateHexMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type DuplicateHexMutation = {
  readonly __typename: "Mutation";
  readonly duplicateHex: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly title: string;
  };
};

export type SetCanEditorsShareMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  canShare: Types.Scalars["Boolean"]["input"];
}>;

export type SetCanEditorsShareMutation = {
  readonly __typename: "Mutation";
  readonly setCanEditorsShare: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly canEditorsShare: boolean;
  };
};

export type SetProjectOrganizationRoleMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  role: Types.InputMaybe<Types.ProjectRole>;
  getSharedComponentCount?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type SetProjectOrganizationRoleMutation = {
  readonly __typename: "Mutation";
  readonly setProjectOrganizationRole: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly organizationRoleV2: Types.ProjectRole | null;
    readonly isShared: boolean;
    readonly logicViewIsShared: boolean;
    readonly org?: {
      readonly __typename: "Org";
      readonly id: c.OrgId;
      readonly sharedComponentCount: number;
    };
  };
};

export type SetProjectPublicRoleMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  role: Types.InputMaybe<Types.ProjectRole>;
}>;

export type SetProjectPublicRoleMutation = {
  readonly __typename: "Mutation";
  readonly setProjectPublicRole: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly publicRoleV2: Types.ProjectRole | null;
    readonly allowPublicDuplication: boolean;
    readonly isShared: boolean;
    readonly logicViewIsShared: boolean;
  };
};

export type SetProjectAllowEmbeddingMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  allowEmbedding: Types.Scalars["Boolean"]["input"];
}>;

export type SetProjectAllowEmbeddingMutation = {
  readonly __typename: "Mutation";
  readonly setProjectAllowEmbedding: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly allowEmbedding: boolean;
  };
};

export type SetAllowPublicDuplicationMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  allowPublicDuplication: Types.Scalars["Boolean"]["input"];
}>;

export type SetAllowPublicDuplicationMutation = {
  readonly __typename: "Mutation";
  readonly setAllowPublicDuplication: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly allowPublicDuplication: boolean;
  };
};

export const HexVersionLogicFragmentDoc = /*#__PURE__*/ gql`
  fragment HexVersionLogicFragment on HexVersion {
    id
    name
    date
    published
    version
    preview
    vcsSyncError
    hex {
      id
      updatedDate
      lastPublishedVersion {
        id
      }
      versions {
        id
        version
      }
    }
  }
`;
export const SaveVersionDocument = /*#__PURE__*/ gql`
  mutation SaveVersion(
    $hexId: HexId!
    $name: String
    $runDefaultAppSession: Boolean!
    $preview: Boolean!
    $pushToGithub: Boolean
    $forcePush: Boolean
    $profileColumns: Boolean
  ) {
    saveNewHexVersion(
      hexId: $hexId
      name: $name
      runDefaultAppSession: $runDefaultAppSession
      preview: $preview
      pushToGithub: $pushToGithub
      forcePush: $forcePush
      profileColumns: $profileColumns
    ) {
      ...HexVersionLogicFragment
    }
  }
  ${HexVersionLogicFragmentDoc}
`;
export type SaveVersionMutationFn = Apollo.MutationFunction<
  SaveVersionMutation,
  SaveVersionMutationVariables
>;

/**
 * __useSaveVersionMutation__
 *
 * To run a mutation, you first call `useSaveVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveVersionMutation, { data, loading, error }] = useSaveVersionMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      name: // value for 'name'
 *      runDefaultAppSession: // value for 'runDefaultAppSession'
 *      preview: // value for 'preview'
 *      pushToGithub: // value for 'pushToGithub'
 *      forcePush: // value for 'forcePush'
 *      profileColumns: // value for 'profileColumns'
 *   },
 * });
 */
export function useSaveVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveVersionMutation,
    SaveVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SaveVersionMutation, SaveVersionMutationVariables>(
    SaveVersionDocument,
    options,
  );
}
export type SaveVersionMutationHookResult = ReturnType<
  typeof useSaveVersionMutation
>;
export type SaveVersionMutationResult =
  Apollo.MutationResult<SaveVersionMutation>;
export type SaveVersionMutationOptions = Apollo.BaseMutationOptions<
  SaveVersionMutation,
  SaveVersionMutationVariables
>;
export const PublishVersionDocument = /*#__PURE__*/ gql`
  mutation PublishVersion(
    $hexId: HexId!
    $name: String
    $version: HexVersionString!
    $forcePush: Boolean
    $screenshotAppSessionId: AppSessionId
  ) {
    publishHexVersion(
      hexId: $hexId
      name: $name
      version: $version
      forcePush: $forcePush
      screenshotAppSessionId: $screenshotAppSessionId
    ) {
      ...HexVersionLogicFragment
    }
  }
  ${HexVersionLogicFragmentDoc}
`;
export type PublishVersionMutationFn = Apollo.MutationFunction<
  PublishVersionMutation,
  PublishVersionMutationVariables
>;

/**
 * __usePublishVersionMutation__
 *
 * To run a mutation, you first call `usePublishVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishVersionMutation, { data, loading, error }] = usePublishVersionMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      name: // value for 'name'
 *      version: // value for 'version'
 *      forcePush: // value for 'forcePush'
 *      screenshotAppSessionId: // value for 'screenshotAppSessionId'
 *   },
 * });
 */
export function usePublishVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishVersionMutation,
    PublishVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishVersionMutation,
    PublishVersionMutationVariables
  >(PublishVersionDocument, options);
}
export type PublishVersionMutationHookResult = ReturnType<
  typeof usePublishVersionMutation
>;
export type PublishVersionMutationResult =
  Apollo.MutationResult<PublishVersionMutation>;
export type PublishVersionMutationOptions = Apollo.BaseMutationOptions<
  PublishVersionMutation,
  PublishVersionMutationVariables
>;
export const RestoreVersionDocument = /*#__PURE__*/ gql`
  mutation RestoreVersion($hexId: HexId!, $version: HexVersionString!) {
    restoreHexVersion(hexId: $hexId, version: $version) {
      id
      name
      date
      published
      hex {
        id
        updatedDate
        versions {
          id
          version
          name
          date
          published
        }
      }
    }
  }
`;
export type RestoreVersionMutationFn = Apollo.MutationFunction<
  RestoreVersionMutation,
  RestoreVersionMutationVariables
>;

/**
 * __useRestoreVersionMutation__
 *
 * To run a mutation, you first call `useRestoreVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreVersionMutation, { data, loading, error }] = useRestoreVersionMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useRestoreVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestoreVersionMutation,
    RestoreVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RestoreVersionMutation,
    RestoreVersionMutationVariables
  >(RestoreVersionDocument, options);
}
export type RestoreVersionMutationHookResult = ReturnType<
  typeof useRestoreVersionMutation
>;
export type RestoreVersionMutationResult =
  Apollo.MutationResult<RestoreVersionMutation>;
export type RestoreVersionMutationOptions = Apollo.BaseMutationOptions<
  RestoreVersionMutation,
  RestoreVersionMutationVariables
>;
export const DeleteHexDocument = /*#__PURE__*/ gql`
  mutation DeleteHex(
    $hexId: HexId!
    $getProjectCount: Boolean = false
    $getSharedComponentCount: Boolean = false
  ) {
    deleteHex(hexId: $hexId) {
      id
      trashDate
      org {
        id
        projectCount @include(if: $getProjectCount)
        sharedComponentCount @include(if: $getSharedComponentCount)
      }
    }
  }
`;
export type DeleteHexMutationFn = Apollo.MutationFunction<
  DeleteHexMutation,
  DeleteHexMutationVariables
>;

/**
 * __useDeleteHexMutation__
 *
 * To run a mutation, you first call `useDeleteHexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHexMutation, { data, loading, error }] = useDeleteHexMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      getProjectCount: // value for 'getProjectCount'
 *      getSharedComponentCount: // value for 'getSharedComponentCount'
 *   },
 * });
 */
export function useDeleteHexMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteHexMutation,
    DeleteHexMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteHexMutation, DeleteHexMutationVariables>(
    DeleteHexDocument,
    options,
  );
}
export type DeleteHexMutationHookResult = ReturnType<
  typeof useDeleteHexMutation
>;
export type DeleteHexMutationResult = Apollo.MutationResult<DeleteHexMutation>;
export type DeleteHexMutationOptions = Apollo.BaseMutationOptions<
  DeleteHexMutation,
  DeleteHexMutationVariables
>;
export const HardDeleteHexDocument = /*#__PURE__*/ gql`
  mutation HardDeleteHex($hexId: HexId!) {
    hardDeleteHex(hexId: $hexId)
  }
`;
export type HardDeleteHexMutationFn = Apollo.MutationFunction<
  HardDeleteHexMutation,
  HardDeleteHexMutationVariables
>;

/**
 * __useHardDeleteHexMutation__
 *
 * To run a mutation, you first call `useHardDeleteHexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHardDeleteHexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hardDeleteHexMutation, { data, loading, error }] = useHardDeleteHexMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useHardDeleteHexMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HardDeleteHexMutation,
    HardDeleteHexMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HardDeleteHexMutation,
    HardDeleteHexMutationVariables
  >(HardDeleteHexDocument, options);
}
export type HardDeleteHexMutationHookResult = ReturnType<
  typeof useHardDeleteHexMutation
>;
export type HardDeleteHexMutationResult =
  Apollo.MutationResult<HardDeleteHexMutation>;
export type HardDeleteHexMutationOptions = Apollo.BaseMutationOptions<
  HardDeleteHexMutation,
  HardDeleteHexMutationVariables
>;
export const RestoreHexDocument = /*#__PURE__*/ gql`
  mutation RestoreHex($hexId: HexId!) {
    restoreHex(hexId: $hexId) {
      id
      trashDate
      canEdit
      canShare
    }
  }
`;
export type RestoreHexMutationFn = Apollo.MutationFunction<
  RestoreHexMutation,
  RestoreHexMutationVariables
>;

/**
 * __useRestoreHexMutation__
 *
 * To run a mutation, you first call `useRestoreHexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreHexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreHexMutation, { data, loading, error }] = useRestoreHexMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useRestoreHexMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestoreHexMutation,
    RestoreHexMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RestoreHexMutation, RestoreHexMutationVariables>(
    RestoreHexDocument,
    options,
  );
}
export type RestoreHexMutationHookResult = ReturnType<
  typeof useRestoreHexMutation
>;
export type RestoreHexMutationResult =
  Apollo.MutationResult<RestoreHexMutation>;
export type RestoreHexMutationOptions = Apollo.BaseMutationOptions<
  RestoreHexMutation,
  RestoreHexMutationVariables
>;
export const DuplicateHexDocument = /*#__PURE__*/ gql`
  mutation DuplicateHex($hexId: HexId!) {
    duplicateHex(hexId: $hexId) {
      id
      title
    }
  }
`;
export type DuplicateHexMutationFn = Apollo.MutationFunction<
  DuplicateHexMutation,
  DuplicateHexMutationVariables
>;

/**
 * __useDuplicateHexMutation__
 *
 * To run a mutation, you first call `useDuplicateHexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateHexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateHexMutation, { data, loading, error }] = useDuplicateHexMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useDuplicateHexMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateHexMutation,
    DuplicateHexMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DuplicateHexMutation,
    DuplicateHexMutationVariables
  >(DuplicateHexDocument, options);
}
export type DuplicateHexMutationHookResult = ReturnType<
  typeof useDuplicateHexMutation
>;
export type DuplicateHexMutationResult =
  Apollo.MutationResult<DuplicateHexMutation>;
export type DuplicateHexMutationOptions = Apollo.BaseMutationOptions<
  DuplicateHexMutation,
  DuplicateHexMutationVariables
>;
export const SetCanEditorsShareDocument = /*#__PURE__*/ gql`
  mutation SetCanEditorsShare($hexId: HexId!, $canShare: Boolean!) {
    setCanEditorsShare(hexId: $hexId, canShare: $canShare) {
      id
      canEditorsShare
    }
  }
`;
export type SetCanEditorsShareMutationFn = Apollo.MutationFunction<
  SetCanEditorsShareMutation,
  SetCanEditorsShareMutationVariables
>;

/**
 * __useSetCanEditorsShareMutation__
 *
 * To run a mutation, you first call `useSetCanEditorsShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCanEditorsShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCanEditorsShareMutation, { data, loading, error }] = useSetCanEditorsShareMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      canShare: // value for 'canShare'
 *   },
 * });
 */
export function useSetCanEditorsShareMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCanEditorsShareMutation,
    SetCanEditorsShareMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCanEditorsShareMutation,
    SetCanEditorsShareMutationVariables
  >(SetCanEditorsShareDocument, options);
}
export type SetCanEditorsShareMutationHookResult = ReturnType<
  typeof useSetCanEditorsShareMutation
>;
export type SetCanEditorsShareMutationResult =
  Apollo.MutationResult<SetCanEditorsShareMutation>;
export type SetCanEditorsShareMutationOptions = Apollo.BaseMutationOptions<
  SetCanEditorsShareMutation,
  SetCanEditorsShareMutationVariables
>;
export const SetProjectOrganizationRoleDocument = /*#__PURE__*/ gql`
  mutation SetProjectOrganizationRole(
    $hexId: HexId!
    $role: ProjectRole
    $getSharedComponentCount: Boolean = false
  ) {
    setProjectOrganizationRole(hexId: $hexId, role: $role) {
      id
      organizationRoleV2
      isShared
      logicViewIsShared
      org @include(if: $getSharedComponentCount) {
        id
        sharedComponentCount
      }
    }
  }
`;
export type SetProjectOrganizationRoleMutationFn = Apollo.MutationFunction<
  SetProjectOrganizationRoleMutation,
  SetProjectOrganizationRoleMutationVariables
>;

/**
 * __useSetProjectOrganizationRoleMutation__
 *
 * To run a mutation, you first call `useSetProjectOrganizationRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectOrganizationRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectOrganizationRoleMutation, { data, loading, error }] = useSetProjectOrganizationRoleMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      role: // value for 'role'
 *      getSharedComponentCount: // value for 'getSharedComponentCount'
 *   },
 * });
 */
export function useSetProjectOrganizationRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetProjectOrganizationRoleMutation,
    SetProjectOrganizationRoleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetProjectOrganizationRoleMutation,
    SetProjectOrganizationRoleMutationVariables
  >(SetProjectOrganizationRoleDocument, options);
}
export type SetProjectOrganizationRoleMutationHookResult = ReturnType<
  typeof useSetProjectOrganizationRoleMutation
>;
export type SetProjectOrganizationRoleMutationResult =
  Apollo.MutationResult<SetProjectOrganizationRoleMutation>;
export type SetProjectOrganizationRoleMutationOptions =
  Apollo.BaseMutationOptions<
    SetProjectOrganizationRoleMutation,
    SetProjectOrganizationRoleMutationVariables
  >;
export const SetProjectPublicRoleDocument = /*#__PURE__*/ gql`
  mutation SetProjectPublicRole($hexId: HexId!, $role: ProjectRole) {
    setProjectPublicRole(hexId: $hexId, role: $role) {
      id
      publicRoleV2
      allowPublicDuplication
      isShared
      logicViewIsShared
    }
  }
`;
export type SetProjectPublicRoleMutationFn = Apollo.MutationFunction<
  SetProjectPublicRoleMutation,
  SetProjectPublicRoleMutationVariables
>;

/**
 * __useSetProjectPublicRoleMutation__
 *
 * To run a mutation, you first call `useSetProjectPublicRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectPublicRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectPublicRoleMutation, { data, loading, error }] = useSetProjectPublicRoleMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSetProjectPublicRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetProjectPublicRoleMutation,
    SetProjectPublicRoleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetProjectPublicRoleMutation,
    SetProjectPublicRoleMutationVariables
  >(SetProjectPublicRoleDocument, options);
}
export type SetProjectPublicRoleMutationHookResult = ReturnType<
  typeof useSetProjectPublicRoleMutation
>;
export type SetProjectPublicRoleMutationResult =
  Apollo.MutationResult<SetProjectPublicRoleMutation>;
export type SetProjectPublicRoleMutationOptions = Apollo.BaseMutationOptions<
  SetProjectPublicRoleMutation,
  SetProjectPublicRoleMutationVariables
>;
export const SetProjectAllowEmbeddingDocument = /*#__PURE__*/ gql`
  mutation SetProjectAllowEmbedding($hexId: HexId!, $allowEmbedding: Boolean!) {
    setProjectAllowEmbedding(hexId: $hexId, allowEmbedding: $allowEmbedding) {
      id
      allowEmbedding
    }
  }
`;
export type SetProjectAllowEmbeddingMutationFn = Apollo.MutationFunction<
  SetProjectAllowEmbeddingMutation,
  SetProjectAllowEmbeddingMutationVariables
>;

/**
 * __useSetProjectAllowEmbeddingMutation__
 *
 * To run a mutation, you first call `useSetProjectAllowEmbeddingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectAllowEmbeddingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectAllowEmbeddingMutation, { data, loading, error }] = useSetProjectAllowEmbeddingMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      allowEmbedding: // value for 'allowEmbedding'
 *   },
 * });
 */
export function useSetProjectAllowEmbeddingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetProjectAllowEmbeddingMutation,
    SetProjectAllowEmbeddingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetProjectAllowEmbeddingMutation,
    SetProjectAllowEmbeddingMutationVariables
  >(SetProjectAllowEmbeddingDocument, options);
}
export type SetProjectAllowEmbeddingMutationHookResult = ReturnType<
  typeof useSetProjectAllowEmbeddingMutation
>;
export type SetProjectAllowEmbeddingMutationResult =
  Apollo.MutationResult<SetProjectAllowEmbeddingMutation>;
export type SetProjectAllowEmbeddingMutationOptions =
  Apollo.BaseMutationOptions<
    SetProjectAllowEmbeddingMutation,
    SetProjectAllowEmbeddingMutationVariables
  >;
export const SetAllowPublicDuplicationDocument = /*#__PURE__*/ gql`
  mutation SetAllowPublicDuplication(
    $hexId: HexId!
    $allowPublicDuplication: Boolean!
  ) {
    setAllowPublicDuplication(
      hexId: $hexId
      allowPublicDuplication: $allowPublicDuplication
    ) {
      id
      allowPublicDuplication
    }
  }
`;
export type SetAllowPublicDuplicationMutationFn = Apollo.MutationFunction<
  SetAllowPublicDuplicationMutation,
  SetAllowPublicDuplicationMutationVariables
>;

/**
 * __useSetAllowPublicDuplicationMutation__
 *
 * To run a mutation, you first call `useSetAllowPublicDuplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAllowPublicDuplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAllowPublicDuplicationMutation, { data, loading, error }] = useSetAllowPublicDuplicationMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      allowPublicDuplication: // value for 'allowPublicDuplication'
 *   },
 * });
 */
export function useSetAllowPublicDuplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAllowPublicDuplicationMutation,
    SetAllowPublicDuplicationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAllowPublicDuplicationMutation,
    SetAllowPublicDuplicationMutationVariables
  >(SetAllowPublicDuplicationDocument, options);
}
export type SetAllowPublicDuplicationMutationHookResult = ReturnType<
  typeof useSetAllowPublicDuplicationMutation
>;
export type SetAllowPublicDuplicationMutationResult =
  Apollo.MutationResult<SetAllowPublicDuplicationMutation>;
export type SetAllowPublicDuplicationMutationOptions =
  Apollo.BaseMutationOptions<
    SetAllowPublicDuplicationMutation,
    SetAllowPublicDuplicationMutationVariables
  >;
